var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',[_c('PaymentHeaderTop'),_c('router-view',{staticClass:"w-100"}),_c('PaymentFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }